import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from '../components/Breadcrumb'
import PricingTierLayer from '../components/PricingTierLayer'

function PricingTierPage() {
  return (
     <>
    {/* Master Layouy */}
    <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title={'Pricing Tier'}/>

        {/* Pricing tier layer */}
        <PricingTierLayer/>
    </MasterLayout>
    </>
  )
}

export default PricingTierPage